import {api} from './api'

export default {
  state: {
    fetchingMasterplan: false,
    activeProduct: {
      home: null,
      lot: null,
      facade: null
    },
    enquirySubmission: null,
    homeDetail: null,
    homeSummary: [],
    homeGeojson: null,
    lotClick: null,
    modelHomes: [],
    unfilteredLotSummary: null,
    lotsummary: null,
    lotDetail: null,
    compatibleLotSummary: null,
    masterplanConfig: null,
    masterplanResources: null,
    packageRecordId: null,
    packageSummary: [],
    specHomesList: null,
    packageDetailList: []
  },
  getters: {
    masterplanResources: (state) => {
      return state.masterplanResources;
    },
    masterplanConfig: (state) => {
      return state.masterplanConfig;
    },
    homeGeoJson: (state) => {
      return state.homeGeojson
    },
    homeSummary: (state) => {
      return state.homeSummary
    },
    modelHomes: (state) => {
      return state.modelHomes
    },
    unfilteredLot: (state) => {
      return state.unfilteredLotSummary;
    }
  },
  mutations: {
    setMasterplanConfig(state, payload) {
      state.masterplanConfig = payload;
    },

    getHomeGeoJson(state, payload) {
      state.homeGeojson = payload
    },

    setMasterplanResource(state, payload) {
      state.masterplanResources = payload
    },

    setHomeSummaryList(state, payload) {
      state.homeSummary = payload
    },

    setSpecHomesList(state, payload) {
      state.specHomesList = payload
    },

    setHomeDetail(state, payload) {
      state.homeDetail = payload
    },

    setUnfilteredSummaryList(state, payload) {
      state.unfilteredLotSummary = payload
    },

    setLotSummaryList(state, payload) {
      state.lotsummary = payload
    },

    setLotDetail(state, payload) {
      state.lotDetail = payload
    },

    setModelHomes(state, payload) {
      state.modelHomes = payload
    },

    setCompatibleLotSummaryList(state, payload) {
      state.compatibleLotSummary = payload
    },

    setCompatibleHomeSummaryList(state, payload) {
      state.homeSummary = payload
    },

    setActiveHome(state, payload) {
      state.activeProduct.home = payload
    },

    setPackageCreation(state, payload) {
      state.packageRecordId = payload
    },

    setPackageDetail(state, payload) {
      state.packageDetail = payload
    },

    setPackageDetailList(state, payload) {
      state.packageDetailList = payload
    },

    setPublishedContact(state, payload) {
      state.enquirySubmission = payload
    }
  },
  actions: {
    fetchMasterplanConfig({dispatch, commit, state}) {
      if (state.masterplanConfig) {
        return commit("setMasterplanConfig", state.masterplanConfig);
      }
      if (!this.fetchingMasterplan) {
        this.fetchingMasterplan = true;
        api.fetchMasterplanConfig().then(res => {
          return commit("setMasterplanConfig", res.data.estate.config);
        })
      }
    },

    fetchHomeGeoJson({dispatch, commit, state}) {
      if (state.homeGeojson) {
        return commit("setHomeGeoJson", state.homeGeojson);
      }
      api.fetchHomeGeojson().then(res => {
        return commit("setHomeGeoJson", res.data);
      })
    },

    fetchHomeSummary({dispatch, commit, state}) {
      if (state.homeSummary) {
        commit("setHomeSummaryList", state.homeSummary)
      }
      api.fetchHomeSummaryList().then(res => {
        commit("setHomeSummaryList", res.data)
      })
    },

    fetchCompatibleHomeSummaryList({dispatch, commit, state}, data) {
      const lotCpId = data.lotCpId;
      api.fetchLotSummaryV2(lotCpId).then(lotSummaryRes => {
        const lotSummary = lotSummaryRes.data;
        const clientId = lotSummary.clientid;
        const allocatedBuilderName = lotSummary.allocatedbuildername;
        if (allocatedBuilderName) {
          api.fetchClient(clientId).then(clientRes => {
            const client = clientRes.data;
            const clientCompanyId = client.defaultccid;
            api.fetchPartnerSummaryList(clientId, clientCompanyId).then(partnerSummaryListRes => {
              const partnerSummaryList = partnerSummaryListRes.data;
              const builderClientCompany = partnerSummaryList.partnerList.find(clientCompany => clientCompany.partnercompanyname === allocatedBuilderName);
              if (builderClientCompany) {
                const ownerCcId = builderClientCompany.clientcompanyid;
                api.fetchCompatibleHomeSummaryListByLotCpIdAndOwnerCcId(lotCpId, ownerCcId).then(compatibleHomeSummaryListRes => {
                  commit("setCompatibleHomeSummaryList", compatibleHomeSummaryListRes.data);
                })
              }
            })
          })
        }
      })
    },

    fetchCompatibleLotSummaryList({dispatch, commit, state}, homeid) {
      api.fetchCompatibleLotSummaryList(homeid).then(res => {
        commit("setHomeDetail", res.homesummary);
        commit("setCompatibleLotSummaryList", res.lotsummary);
      })
    },

    fetchLotSummaryList({dispatch, commit, state}) {
      if (state.unfilteredLotSummary && state.modelHomes) {
        commit("setModelHomes", state.modelHomes)
        return commit("setUnfilteredSummaryList", state.unfilteredLotSummary)
      }
      api.fetchLotSummary().then(res => {
        state.unfilteredLotSummary = res.lotsummary;
        state.modelHomes = res.homesummary;
        commit("setModelHomes", res.homesummary);
        commit("setUnfilteredSummaryList", res.lotsummary)
      })
    },

    getPackageSummaryList({dispatch, commit}) {

    },

    getSpecHomesList({dipatch, commit, state}) {
      if (state.specHomesList) {
        return;
      }
      api.getSpecHomesList().then(res => {
        const publishedList = res.data.filter(hnl => {
          if (
            hnl.marketingstatus === "Publish on Website" ||
            hnl.marketingstatus === "Publish On Website"
          ) {
            return hnl;
          }
        });
        commit("setSpecHomesList", publishedList)
      })
    },

    getActiveHome({dipatch, commit, state}, id) {
      if (state.activeHome) {
        commit("setActiveHome", activeHome)
      } else {
        api.fetchHomeSummaryDetail(id).then(res => {
          commit("setActiveHome", res.data);
        })
      }
    },

    getPackageDetail({dipatch, commit, state}, id) {
      api.getPackageDetail(id).then(res => {
        commit("setPackageDetail", res.data)
      })
    },

    getPackageDetailList({dipatch, commit, state}) {
      api.getPackageDetailList().then(res => {
        commit("setPackageDetailList", res.data)
      })
    },

    createPackage({dispatch, commit, state}, ids) {
      api.createPackage(ids).then(res => {
        if (res.data.recordid) {
          dispatch("setFavoriteHnl", res.data.recordid);
          dispatch("goToPackage", res.data.recordid);
        }
      })
    },

    goToPackage({dispatch, commit, state}, packageid) {
      commit("setPackageCreation", packageid)
    },

    setFilteredLotList({dispatch, commit, state}, lotlist) {
      commit("setLotSummaryList", lotlist)
    },

    submitEnquiry({dispatch, commit, state}, formData) {
      api.publishToHubspot(formData.hubspotFormData).then(res => {
        console.log(res);
      })
      api.publishContact(formData.formData).then(res => {
        console.log(res.data);
        commit("setPublishedContact", res.data)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/community.js